<div
  class="main-table-shell"
  (touchstart)="onTableTouchStart($event, tableContainer)"
  (touchmove)="onTableTouchMove($event, tableContainer)"
  (touchend)="onTableTouchEnd($event, tableContainer)"
  (touchcancel)="onTableTouchEnd($event, tableContainer)"
  (wheel)="onTableWheel($event, tableContainer)"
>
  <div
    class="filtering-row"
    [class.mobile-filters-enabled]="mobileFilterToolbarActive"
    [class.has-active-filters]="mobileFiltersActive && activeFilterCount > 0"
    [class.cdk-visually-hidden]="!filteringEnabled"
    appElementResize
    (elementResized)="fitToViewport && fitToViewportDirective.calculateAndSetMaxHeight()"
  >
    <div class="main-table-actions">
      <ng-content></ng-content>
    </div>
    @if (hasTransientFilters) {
      <p class="transient-filters-message">
        {{ 'transientFiltersTooltip' | translate }}
      </p>
    }
    <div class="second-filtering-div">
      @if (hasTransientFilters) {
        <mat-icon
          class="transient-filters-info-icon"
          [matTooltip]="'transientFiltersTooltip' | translate"
          matTooltipPosition="above"
        >
          info_outline
        </mat-icon>
      }
      @if (hasActiveFilters) {
        <app-ui-button
          class="desktop-clear-filters mt-0 mb-0"
          buttonType="secondary"
          text="{{ 'clearAllFilters' | translate }}"
          (click)="clearFilters()"
        ></app-ui-button>
      }
      <!-- <app-main-table-search
    [moduleName]="moduleNameForPaging"
    [totalPages]="totalPages"
    [additional]="additional"
  ></app-main-table-search> -->
      @if (searchingEnabled) {
        <app-ui-input
          class="search-field"
          [control]="searchControl"
          [placeholder]="'search' | translate"
          [ariaLabel]="'search' | translate"
          [prefixIcon]="mobileTableActive ? 'search' : ''"
          [showClearButton]="true"
        ></app-ui-input>
      }
      @if (mobileFiltersActive) {
        <div class="mobile-filters-trigger">
          <app-ui-button
            buttonType="secondary"
            icon="filter_alt"
            [text]="'filters' | translate"
            (click)="openMobileFilters()"
          ></app-ui-button>
          @if (activeFilterCount) {
            <span class="active-filter-count">{{ activeFilterCount }}</span>
          }
        </div>
      }
    </div>
  </div>
  <div
    class="main-table-container"
    #tableContainer
    appFitToViewport
    appElementResize
    #fitToViewportDirective="fitToViewportDirective"
    [ngClass]="{
      'mat-elevation-z8': elevationEnabled,
      'default-height': fitToViewport,
      'mobile-optimized-container': mobileTableActive,
    }"
    [style.--main-table-min-width]="tableMinWidth"
    [bottomOffset]="paginationEnabled ? 57 : 2"
    [minHeight]="mobileFullscreenOnScroll && mobileTableActive ? 0 : 50"
    [fitToViewportDisabled]="!fitToViewport"
    [fillAvailableViewport]="fillAvailableViewport"
    [suspendRecalculation]="mobileFullscreenFitSuspended"
    (elementResized)="onResize($event); fitToViewportDirective.calculateAndSetMaxHeight()"
    (scroll)="onTableScroll(tableContainer)"
  >
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      class="main-table-container"
      [class.mobile-optimized-table]="mobileTableActive"
      [class.mobile-sticky-header]="mobileTableActive && stickyHeader"
      [class.mobile-filters-table]="mobileFiltersActive"
      [class.selection-mode-disabled]="!selectionModeActive"
      multiTemplateDataRows
      (matSortChange)="sortData($event)"
    >
      <ng-container
        matColumnDef="multiselect"
        [sticky]="mobileTableActive && mobileStickyColumns.includes('multiselect')"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [class.mobile-sticky-column]="
            mobileTableActive && mobileStickyColumns.includes('multiselect')
          "
          [class.mobile-sticky-column-end]="
            mobileTableActive && isLastMobileStickyColumn('multiselect')
          "
        >
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="multipleSelection.hasValue() && isAllSelected()"
            [indeterminate]="multipleSelection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          ></mat-checkbox>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [class.mobile-sticky-column]="
            mobileTableActive && mobileStickyColumns.includes('multiselect')
          "
          [class.mobile-sticky-column-end]="
            mobileTableActive && isLastMobileStickyColumn('multiselect')
          "
        >
          @if (!(hideDisabledCheckbox && row[disableSelectionByColumn])) {
            <mat-checkbox
              [disabled]="row[disableSelectionByColumn]"
              (change)="$event ? toggleSingle(row) : null"
              (click)="$event.stopPropagation()"
              [indeterminate]="isSomeRowsInGroupSelected(row) && !isAllRowsInGroupSelected(row)"
              [checked]="multipleSelection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
            ></mat-checkbox>
          }
          @if (hideDisabledCheckbox && row[disableSelectionByColumn] && disabledCheckboxIcon) {
            <mat-icon class="ml-05" [matTooltip]="disabledCheckboxIconTooltip">
              {{ disabledCheckboxIcon }}
            </mat-icon>
          }
        </td>
      </ng-container>
      @for (columnName of columnDefinitions; track columnName) {
        <ng-container
          [matColumnDef]="columnName"
          [sticky]="mobileTableActive && mobileStickyColumns.includes(columnName)"
        >
          @if (filterConfig?.[columnName]) {
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.mobile-compact-column]="
                mobileTableActive && compactMobileColumns.includes(columnName)
              "
              [class.mobile-custom-width-column]="
                mobileTableActive && !!mobileColumnWidths[columnName]
              "
              [style.width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
              [style.min-width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
              [class.mobile-sticky-column]="
                mobileTableActive && mobileStickyColumns.includes(columnName)
              "
              [class.mobile-sticky-column-end]="
                mobileTableActive && isLastMobileStickyColumn(columnName)
              "
              [ngClass]="{
                'border-panel-top': columnPanelMap[columnName]?.inPanel,
                'in-panel': columnPanelMap[columnName]?.inPanel,
                'border-panel-right':
                  columnPanelMap[columnName]?.endIndex === $index &&
                  columnPanelMap[columnName]?.inPanel,
                'border-panel-left':
                  columnPanelMap[columnName]?.startIndex === $index &&
                  columnPanelMap[columnName]?.inPanel,
              }"
            >
              @if (columnName | shouldHeaderBeDisplayed) {
                <button
                  class="column-filter-button"
                  [attr.data-testid]="'main-table-filter-' + columnName"
                  [matMenuTriggerFor]="menu"
                  #trigger="matMenuTrigger"
                  appStopClickPropagation
                >
                  @if (mobileTableActive) {
                    {{ columnTitlesMap[columnName] || (columnName | translate) }}
                  } @else {
                    {{ columnTitlesMap[columnName] || columnName | translate | titlecase }}
                  }
                  @if (
                    (orderByColumn | lowercase) ===
                    (getProperHeaderNameForAPI(columnName, moduleName) | lowercase)
                  ) {
                    @if (sortDirection) {
                      <mat-icon class="active">
                        {{ sortDirection === 'Ascending' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  }
                  <mat-icon [class.active]="columnFilter.hasActiveFilters">filter_list</mat-icon>
                </button>
                <mat-menu
                  #menu="matMenu"
                  class="column-filter-menu"
                  (closed)="columnFilter.initControlsFromInitialFilters()"
                >
                  <app-main-table-column-filter
                    #columnFilter="appMainTableColumnFilter"
                    [initialFilters]="columnFilters[columnName] ?? []"
                    [column]="columnName"
                    [filterConfig]="filterConfig ?? {}"
                    [sortDirection]="
                      (orderByColumn | lowercase) ===
                      (getProperHeaderNameForAPI(columnName, moduleName) | lowercase)
                        ? (sortDirection ?? '')
                        : ''
                    "
                    [sorting]="sortingEnabled && !(disabledColumnHeaders | contains: columnName)"
                    (close)="trigger.closeMenu()"
                    (sort)="sortData($event)"
                    (filter)="applyColumnFilters(columnName, $event)"
                  ></app-main-table-column-filter>
                </mat-menu>
              }
            </th>
          } @else {
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.mobile-compact-column]="
                mobileTableActive && compactMobileColumns.includes(columnName)
              "
              [class.mobile-custom-width-column]="
                mobileTableActive && !!mobileColumnWidths[columnName]
              "
              [style.width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
              [style.min-width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
              [class.mobile-sticky-column]="
                mobileTableActive && mobileStickyColumns.includes(columnName)
              "
              [class.mobile-sticky-column-end]="
                mobileTableActive && isLastMobileStickyColumn(columnName)
              "
              [mat-sort-header]="columnName"
              sortActionDescription="{{ 'sortBy' | translate }} {{ columnName }}"
              [ngClass]="{
                'expand-column': columnName === 'expand',
                'in-panel': columnPanelMap[columnName]?.inPanel,
                'border-panel-top': columnPanelMap[columnName]?.inPanel,
                'border-panel-right':
                  columnPanelMap[columnName]?.endIndex === $index &&
                  columnPanelMap[columnName]?.inPanel,
                'border-panel-left':
                  columnPanelMap[columnName]?.startIndex === $index &&
                  columnPanelMap[columnName]?.inPanel,
              }"
              [disabled]="disabledColumnHeaders | contains: columnName"
            >
              @if (columnName | shouldHeaderBeDisplayed) {
                @if (mobileTableActive) {
                  @if (columnName === 'actions') {
                    {{ 'action' | translate }}
                  } @else {
                    {{ columnTitlesMap[columnName] || (columnName | translate) }}
                  }
                } @else {
                  {{ columnTitlesMap[columnName] || columnName | translate | uppercase }}
                }
              }
            </th>
          }
          <td
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            [class.mobile-compact-column]="
              mobileTableActive && compactMobileColumns.includes(columnName)
            "
            [class.mobile-custom-width-column]="
              mobileTableActive && !!mobileColumnWidths[columnName]
            "
            [style.width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
            [style.min-width]="mobileTableActive ? mobileColumnWidths[columnName] : null"
            [class.mobile-sticky-column]="
              mobileTableActive && mobileStickyColumns.includes(columnName)
            "
            [class.mobile-sticky-column-end]="
              mobileTableActive && isLastMobileStickyColumn(columnName)
            "
            [ngClass]="{
              'expired-due-list': element.status === 'Expired',
              'expiring-due-list': element.status === 'Expiring',
              'in-panel': columnPanelMap[columnName]?.inPanel,
              'border-panel-right':
                columnPanelMap[columnName]?.endIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
              'border-panel-left':
                columnPanelMap[columnName]?.startIndex === $index &&
                columnPanelMap[columnName]?.inPanel,
              'pointer-cursor': clickableColumns.includes(columnName),
              'main-table-column-hover-accent': !!columnHoverTooltips[columnName],
            }"
            [matTooltip]="
              columnHoverTooltips[columnName] ? (columnHoverTooltips[columnName] | translate) : ''
            "
            [matTooltipPosition]="columnHoverTooltips[columnName] ? 'left' : 'below'"
            [matTooltipDisabled]="!columnHoverTooltips[columnName]"
          >
            @if (element | isArray) {
              <a mat-button>
                @for (singleElement of element.columnName; track $index) {
                  <div>
                    {{ singleElement }}
                  </div>
                }
              </a>
            } @else {
              @if (columnName === 'expand') {
                @if (element.expandable !== false) {
                  @if (expandedElement !== element) {
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  }
                  @if (expandedElement === element) {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  }
                }
              } @else {
                <app-main-table-module-specific-template
                  [module]="moduleName"
                  [columnName]="columnName"
                  [element]="element"
                  [urlForRouting]="urlForRow"
                  [specificTemplateName]="specificTemplateName"
                  [buttonFunctions]="buttonFunctions | passArgumentsToObjFunctions: i"
                  [hideButtons]="hideButtons"
                  (click)="handleColumnClick($event, columnName, element)"
                ></app-main-table-module-specific-template>
              }
            }
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="subHeader" [sticky]="mobileTableActive">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="mobileTableActive ? null : renderedColumns.length"
          class="subheader-column"
        >
          <div
            class="subheader-sticky-content"
            [style.width.px]="
              mobileTableActive && subheaderContentWidth ? subheaderContentWidth : null
            "
          >
            {{
              !!element['address']?.subscribe ? (element['address'] | async) : element['address']
            }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="subHeaderRemainder">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="subheaderRemainderColspan"
          class="subheader-remainder-column"
        ></td>
      </ng-container>

      <ng-container matColumnDef="maintenanceJobsGroupName" [sticky]="mobileTableActive">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="
            mobileTableActive ? null : renderedColumns.length - (showSelector ? 1 : 0)
          "
          class="maintenance-job-subheader-column"
        >
          <div
            class="maintenance-job-subheader-container"
            [style.width.px]="
              mobileTableActive && subheaderContentWidth ? subheaderContentWidth : null
            "
          >
            <span class="maintenance-job-group-name" [attr.title]="element.name">
              {{ element.name }}
            </span>

            <span class="sub-header-badge">{{ element.expiredJobsCount }}</span>
            <span class="sub-header-attributes">
              @if (element.isCriticalComponent) {
                <mat-icon [matTooltip]="'criticalComponent' | translate">warning</mat-icon>
              }
              @if (element.isE0Component) {
                <mat-icon [matTooltip]="'E0Component' | translate">visibility</mat-icon>
              }
              @if (element.isClassComponent && !!element.classId) {
                <mat-icon [matTooltip]="('classId' | translate) + ': ' + element.classId">
                  health_and_safety
                </mat-icon>
              }
            </span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="maintenanceJobsGroupRemainder">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="maintenanceSubheaderRemainderColspan"
          class="subheader-remainder-column"
        ></td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="renderedColumns.length"
          class="no-padding"
        >
          @if (
            needExpandableRowLoader &&
            element === expandedElement &&
            (expandableRowLoadingActions | actionInProgress: true | async) === true
          ) {
            <div class="loader" *appLoader="true"></div>
          }
          @if (isExpandable && element === expandedElement) {
            <div
              class="element-detail"
              [class.element-detail--nested-data]="
                !!expandableRowDataField && !expandableRowNestedTable
              "
            >
              <app-main-table-expandable-row
                [class.cdk-visually-hidden]="
                  needExpandableRowLoader &&
                  (expandableRowLoadingActions | actionInProgress: true | async) === true
                "
                [displayedColumns]="renderedColumns"
                [detailsDisplayedColumns]="detailsDisplayedColumns"
                [specificTemplateName]="specificTemplateName"
                [moduleName]="moduleName"
                [parentRow]="element"
                [urlForRow]="urlForRow"
                [disabledColumnHeaders]="disabledColumnHeaders"
                [clickableColumns]="clickableColumns"
                [columnTitlesMap]="columnTitlesMap"
                [expandableRowDataField]="expandableRowDataField"
                [expandableRowNestedTable]="expandableRowNestedTable"
                [expandableRowEmptyLabel]="expandableRowEmptyLabel"
                [tableData]="runTimeChildElements()"
                (columnHandler)="handleChildColumnClick($event)"
              ></app-main-table-expandable-row>
            </div>
          }
        </td>
      </ng-container>

      @if (showHeaders && panelConfig) {
        <tr class="panel-headers">
          @for (panel of panelConfig; track panel.startIndex) {
            <td [attr.colspan]="panel.length" class="panel-header" [class.filled]="!!panel.title">
              {{ panel.title }}
            </td>
          }
        </tr>
      }
      @if (showHeaders) {
        <tr
          mat-header-row
          *matHeaderRowDef="tableRenderedColumns; sticky: mobileTableActive && stickyHeader"
        ></tr>
      }
      <tr
        *matRowDef="let row; columns: tableRenderedColumns"
        mat-row
        [class.cdk-visually-hidden]="row.isSubHeader"
        [class.pointer-cursor]="
          !rowClickDisabled &&
          (isExpandable || urlForRow.length > 1 || rowHandler.observers.length > 0)
        "
        [class.expanded-row]="expandedElement === row"
        [ngClass]="[trClass || '', trClassMap[row[idFieldNameForRowHandler] || row.id] || '']"
        (click)="handleRowClick(row)"
      ></tr>
      <tr
        *matRowDef="let row; columns: ['expandedDetail']"
        [class.cdk-visually-hidden]="row.isSubHeader || !isExpandable"
        mat-row
        class="detail-row"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: maintenanceSubheaderColumns"
        [class.cdk-visually-hidden]="
          !row.isMaintenanceJobGroup || (hideDisabledCheckbox && row[disableSelectionByColumn])
        "
        class="subheader-row subheader-maintenance-job-group"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: subheaderColumns"
        [class.cdk-visually-hidden]="!row.isSubHeader || row.isMaintenanceJobGroup"
        class="subheader-row"
      ></tr>
      <!-- Row shown when there is no matching data. -->
      @if (filteringEnabled) {
        <tr class="mat-row" *matNoDataRow>
          @if (filterValue) {
            <td class="mat-cell" [attr.colspan]="tableRenderedColumns.length">
              {{ 'noDataMatchingTheFilter' | translate }} "{{ filterValue }}"
            </td>
          }
          @if (!filterValue) {
            <td class="mat-cell" [attr.colspan]="tableRenderedColumns.length">
              {{ 'thereIsCurrentlyNoDataInTheTable' | translate }}
            </td>
          }
        </tr>
      }
    </table>
  </div>
  @if (paginationEnabled) {
    <app-main-table-paginator
      aria-label="Select page of items"
      class="paginator"
      [moduleName]="moduleNameForPaging"
      [totalPages]="totalPages"
      [additional]="additional"
      [showPageSizeSelector]="showPageSizeSelector"
      [initialPageSize]="defaultInitialPageSize"
      [skipInitialLoad]="skipInitialLoad"
      [initialFilters]="initialFilters"
      [ngClass]="{
        'main-table-paginator': viewMode === 'full',
      }"
    ></app-main-table-paginator>
  }
</div>
@if (loading) {
  <div class="loader" *appLoader="true"></div>
}
